import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request/request'

import { handlerServerError } from '@orbit/errors'

export const useHook = ({ onSuccess, onError }: { onSuccess: () => void; onError: (error) => void }) =>
  useMutation({
    mutationFn: (opts: { companyId: number; ids: string[] }) =>
      Request.put(Request.urls.bank.companyUsersAssignment, {
        companyId: opts.companyId,
        bankUserIds: opts.ids
      }),
    onSuccess,
    onError
  })

export const useSetCompanyOwners = (resetWebpage: () => void) => {
  const { mutate } = useHook({
    onSuccess: async () => {
      resetWebpage()
    },
    onError: (error) => handlerServerError(error)
  })

  return {
    onSetCompanyOwners: mutate
  }
}
